import LimitField from "./LimitField.jsx"

export default function EmailCampaignForm({ options, config, setConfig }) {
  const campaigns = options?.campaigns ?? []
  const value = config.campaign_id ?? ""

  return (
    <div className="space-y-3">
      <label className="block">
        <span className="text-xs font-medium text-muted-foreground">Campaign</span>
        <select value={value}
                onChange={e => setConfig({ ...config, campaign_id: Number(e.target.value) || null })}
                className="mt-1 w-full h-9 px-2 rounded-md border border-border bg-background text-sm">
          <option value="">Pick a campaign…</option>
          {campaigns.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
        {campaigns.length === 0 && (
          <p className="text-[11px] text-muted-foreground mt-1">
            No uncompleted campaigns in this project yet. Create one under <strong>Email Marketing → Campaigns</strong>.
          </p>
        )}
      </label>

      <LimitField config={config} setConfig={setConfig} />
    </div>
  )
}
